module.exports = __webpack_public_path__ + "static/glass-ceiling-843b16815dea3693dadec4425d77f591.jpg";